/* eslint-disable react/jsx-key */
import { useEffect, useState } from 'react';
import Footer from '@/components/Layout/Footer/Footer';
import proimg from '@/assets/pro-img.png';
import pror from '@/assets/pro-r-img.png';
import checks from '@/assets/pay.png';
import { ContentLayout } from '@/components/Layout';
import { Button } from '@/components/Elements';
import i18next from 'i18next';
import AgencyCards from './AgencyCards';
import AcceptedRequest from './AcceptedRequest';
import Finalized from './Finalized';
import ViewRequested from './ViewRequested';

export const AgencyDetails = () => {
  const [activeTab, setActiveTab] = useState('Property');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Property':
        return <AgencyCards />;
      case 'Requested':
        return <AgencyCards />;
      case 'Accepted':
        return <AcceptedRequest />;
      case 'Finalized':
        return <Finalized />;
      default:
        return null;
    }
  };
  return (
    <>
      <ContentLayout title={i18next.t('Agency Details')}>
        <section className="inner-banner sub agency">
          <div
            className="faq-banner rounded-50 mx-3 "
            style={{ backgroundImage: `url(${proimg})` }}
          >
            <div className="bg-overlay py-md-3 px-md-5 p-3">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="profile-content">
                      <h2 className="fw-400 text-white f-40">Agency Deals</h2>
                      <p className="text-white fw-400">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Faucibus in libero
                        risus semper habitant arcu eget. Et integer facilisi eget. Lorem ipsum
                        dolor.{' '}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="pro-right-img ">
                      <img src={pror} alt="img" className="img-fluid w-75 ms-auto" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="agency-tabssec">
          <div className="container">
            <div className="agency-tab-btns">
              <div className="agency-filter-tb gap-2 d-flex align-items-center">
                <Button
                  className={activeTab === 'Property' ? 'active' : ''}
                  onClick={() => setActiveTab('Property')}
                >
                  Property Listing
                </Button>
                <Button
                  className={activeTab === 'Requested' ? 'active' : ''}
                  onClick={() => setActiveTab('Requested ')}
                >
                  Requested Agency
                </Button>
                <Button
                  className={activeTab === 'Accepted' ? 'active' : ''}
                  onClick={() => setActiveTab('Accepted')}
                >
                  Accepted Request
                </Button>
                <Button
                  className={activeTab === 'Finalized' ? 'active' : ''}
                  onClick={() => setActiveTab('Finalized')}
                >
                  Finalized Agency
                </Button>
              </div>
              <div className="filtred-agency-content">{renderTabContent()}</div>
            </div>
          </div>
        </section>
        <Footer />
      </ContentLayout>
    </>
  );
};
